/* Svensk katalog for locale-demo-reset-shortcut.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'demoReset.button': 'Återställ demo',
  'demoReset.title': 'Återställ demoföretaget',
  'demoReset.message': 'Detta tar permanent bort alla bokförings- och driftsdata i det här demoföretaget. Åtgärden kan inte ångras.',
  'demoReset.preserved': 'Företagsprofilen, medlemmar, abonnemang och integrationskopplingar behålls.',
  'demoReset.phrase': 'BEKRÄFTA',
  'demoReset.typeLabel': 'Skriv {phrase} för att aktivera återställning',
  'demoReset.typeHint': 'Kontrollera att rätt demoföretag är valt innan du fortsätter.',
  'demoReset.confirm': 'Ta bort och återställ demo',
  'demoReset.complete': 'Demoföretaget är återställt.',
  'demoReset.failed': 'Kunde inte återställa demoföretaget.',
  'demoReset.reason': 'Användaren bekräftade snabbåterställning av demoföretaget genom att skriva det obligatoriska bekräftelseordet.',
  'demoReset.settingTitle': 'Visa snabbknapp för återställning',
  'demoReset.settingHelp': 'Visar ”Återställ demo” ovanför SuperPlumma för det här företaget. Andra företag på demokontot styrs separat.',
  'demoReset.settingEnabled': 'Snabbknappen är aktiverad för det här demoföretaget.',
  'demoReset.settingDisabled': 'Snabbknappen är inaktiverad.',
});
